import React, { useMemo } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { AnimatePresence } from 'framer-motion';
import Layout from './components/Layout.jsx';
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import Projects from './pages/Projects.jsx';
import Skills from './pages/Skills.jsx';
import Testimonials from './pages/Testimonials.jsx';
import Contact from './pages/Contact.jsx';
import Admin from './pages/admin/Admin.jsx';
import Login from './pages/admin/Login.jsx';
import useAuthStore from './store/authStore.js';
import useUIStore from './store/uiStore.js';
import { Analytics } from '@vercel/analytics/react';

function useAppTheme() {
  const mode = useUIStore((s) => s.mode);
  return useMemo(() => createTheme({
    palette: {
      mode,
      background: mode === 'dark' ? { default: '#0b0f15', paper: '#0f1622' } : { default: '#f6f8fb', paper: '#ffffff' },
      primary: { main: '#64b5f6' },
      secondary: { main: '#90caf9' }
    },
    typography: {
      fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif'
    },
    shape: { borderRadius: 12 }
  }), [mode]);
}

function ProtectedRoute({ children }) {
  const isAuthed = useAuthStore((s) => s.isAuthenticated);
  if (!isAuthed) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  const theme = useAppTheme();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Analytics />
      <Layout>
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AnimatePresence>
      </Layout>
    </ThemeProvider>
  );
}


